import {
    CREATE_ADS_CAMPAIGN,
    GET_CAMPAIGN_LIST,
    UPDATE_CAMPAIGN,
    INVOICE_CREATION
  } from "./type";
  
  const initialState = {
    createAdsCampaign: [],
    getCampaignListing: [],
    updateStatusForCampaign: [],
    invoiceCreationAgainstCampaign: [],
  }
  
  const campaignReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ADS_CAMPAIGN:
        return {
          ...state,
          createAdsCampaign: payload,
        };
      case GET_CAMPAIGN_LIST:
        return {
          ...state,
          getCampaignListing: payload,
        };
      case UPDATE_CAMPAIGN:
        return {
          ...state,
          updateStatusForCampaign: payload,
        };
      case INVOICE_CREATION:
        return {
          ...state,
          invoiceCreationAgainstCampaign: payload,
        };
      default:
        return {
          ...state,
        };
    }
  };
  
  export default campaignReducer;